import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import HoverOver from '../HoverOver';
import AreaChartGrid from "./AreaChartGrid";

import './AreaChart.css';
import HoverLines from "./HoverLines";

class AreaChart extends Component {

  constructor(props) {
    super(props);

    this.state = {
      margin: {left: 50, right: 50, top: 20, bottom: 30},
      width: 500,
      height: props.height || 200,
      hoverX: -1,
      hoverY: -1,
      hoverType: null
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    this.setState({width: width});
  }

  render() {
    const innerWidth = this.state.width - this.state.margin.left - this.state.margin.right;
    const innerHeight = this.state.height - this.state.margin.top - this.state.margin.bottom;

    return (
      <div ref="wrapper" className="AreaChart">
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <g transform={"translate(" + this.state.margin.left + "," + this.state.margin.top + ")"} ref="svg">
            <AreaChartGrid
              width={innerWidth}
              height={innerHeight}
              titleY={this.props.titleY}
              titleX={this.props.titleX}
              dimY={this.props.dimY}
              dimX={this.props.dimX}
              year={this.props.year}
              data={this.props.data}
              onHoverOver={hover =>{
                this.setState({
                  hover,
                  hoverX: hover.coords[0],
                  hoverY: hover.coords[1],
                  hoverType: hover.data.type
                })
              }}
              onHoverOut={() => {
                this.setState({
                  hover: null,
                  hoverX: -1,
                  hoverY: -1,
                  hoverType: null
                })
              }}
              onClick={year => {
                if (this.props.onClick) {
                  this.props.onClick(year);
                }
              }}
            />
            <HoverLines
              hoverX={this.state.hoverX}
              hoverY={this.state.hoverY}
              width={innerWidth}
              height={innerHeight}
              type={this.state.hoverType}
            />
          </g>
        </svg>

        <HoverOver data={this.state.hover} {...this.state.margin}/>
      </div>
    );
  }
}

AreaChart.propTypes = {
  type: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  titleX: PropTypes.string,
  titleY: PropTypes.string,
  year: PropTypes.number,
  data: PropTypes.object,
  onClick: PropTypes.func
};

export default AreaChart;




// WEBPACK FOOTER //
// ./src/charts/AreaChart/index.js